import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "modal-process-progress-export__title" };
const _hoisted_2 = { class: "modal-process-progress-export__bar" };
const _hoisted_3 = { class: "modal-process-progress-export__percentage" };
const _hoisted_4 = { class: "modal-process-progress-export__track" };
import { watch, computed } from 'vue';
import { postCancelExportImportJob } from '@/features/AudienceManager/data';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import i18n from '@/i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalProcessProgress',
    setup(__props, { expose: __expose }) {
        const store = useStore();
        const toast = useToast();
        const showModal = computed(() => store.state.audienceManager.showModal.progress);
        const progressBar = computed(() => store.getters['audienceManager/progressBar']);
        const batchId = computed(() => store.getters['audienceManager/batchId']);
        const resultCode = computed(() => store.getters['audienceManager/resultCode']);
        const resultNotFound = computed(() => resultCode.value === 'no-results-found');
        const isVisible = computed({
            get: () => showModal.value,
            set: value => {
                store.commit('audienceManager/UPDATE_VISIBILITY_MODAL', { type: 'progress', value });
            },
        });
        const showToast = () => {
            if (resultNotFound.value) {
                toast.warning(i18n.global.t('audiences.no-results'), { timeout: 3000 });
            }
        };
        const open = () => {
            isVisible.value = true;
        };
        const close = () => {
            if (!resultNotFound.value && batchId.value) {
                postCancelExportImportJob(batchId.value);
            }
            showToast();
        };
        watch(() => progressBar.value, value => {
            if (value === 100)
                close();
        });
        watch(() => isVisible.value, shouldOpen => {
            if (!shouldOpen && !resultNotFound.value && batchId.value) {
                postCancelExportImportJob(batchId.value);
            }
        });
        const cancelRequest = () => {
            if (batchId.value) {
                postCancelExportImportJob(batchId.value);
            }
            close();
        };
        __expose({ open });
        return (_ctx, _cache) => {
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: isVisible.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isVisible).value = $event)),
                class: "modal-process-progress-export",
                "append-to-body": "",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "show-close": false
            }, {
                default: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('spinner')), 1),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(progressBar.value) + "%", 1),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", {
                                class: "modal-process-progress-export__fill",
                                style: _normalizeStyle({ width: progressBar.value + '%' })
                            }, null, 4)
                        ])
                    ]),
                    _createElementVNode("button", {
                        class: "btn btn-outline-ctx-primary modal-process-progress-export__cancel-btn",
                        onClick: cancelRequest
                    }, _toDisplayString(_ctx.$t('cancel')), 1)
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
